import { render, staticRenderFns } from "./PatientInformationVerify.vue?vue&type=template&id=f1d64afe&scoped=true&"
import script from "./PatientInformationVerify.vue?vue&type=script&lang=js&"
export * from "./PatientInformationVerify.vue?vue&type=script&lang=js&"
import style0 from "./PatientInformationVerify.vue?vue&type=style&index=0&id=f1d64afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.registry.npmjs.org/vue-loader/15.9.8_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d64afe",
  null
  
)

export default component.exports